module.exports = "<p>\n  {{ 'app.error.not_found' | translate }}\n</p>\n"